<template>
    <v-container fluid >

      <!-- toasts message -->
      <v-card color="grey lighten-4" style="text-align:'left'">
        <v-snackbar
        :timeout="SnackbarVal.timeout"
        :color="SnackbarVal.color"
        top="top"        
        v-model="SnackbarVal.snackbar"
        >        
        {{ SnackbarVal.message }}
            </v-snackbar>
        </v-card>
        <!-- /toasts message -->

        <v-layout align-center justify-center style="margin-bottom:40px">
            <v-flex xs12 sm8 md5>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">                         
                        <v-toolbar-title >
                            <a href="https://10.42.140.218:81" target="_blank" style="color:#ffffff; text-decoration:none">
                             IPFF Project 
                             </a>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <img aspect-ratio="1" :src="`${FrontendPath}/public/dashboard/dashboard.png`" height="50px">
                    </v-toolbar>
                </v-card>
            </v-flex>
        </v-layout>


        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md5>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">                         
                        <v-toolbar-title >Login form</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <img aspect-ratio="1" :src="`${FrontendPath}/public/dashboard/dashboard.png`" height="50px">
                    </v-toolbar>

                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-card-text>    
                            <v-select
                            label="Select Project"
                            item-text="project_name_short"
                            item-value="id"
                            v-model="user.project_id"
                            :items="projectList"
                            :rules="[v => !!v || 'Designation is required !']"
                            required>
                        </v-select>                          

                        <v-text-field
                        label="User ID"
                        v-model="user.email"
                        :rules="emailRules"
                        required
                        ></v-text-field>

                        <v-text-field
                        type="password"
                        label="Password"
                        v-model="user.password"
                        :rules="passwordRules"
                        required
                        ></v-text-field>


                    </v-card-text>
                    <v-card-actions>
                        <div v-model="loadingIcon" v-if="loadingIcon">
                            <v-progress-circular 
                            :width="3"
                            color="red"
                            indeterminate>

                        </v-progress-circular>
                    </div>
                    <div v-model="successStatus" v-if="successStatus">
                        <p style="color: green;"> Login Successfull... </p>
                    </div>
                    <div v-model="failStatus" v-if="failStatus">
                        <p style="color: red;"> Login failed! Invalid email or password </p>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                    @click="submit"
                    :disabled="!valid"
                    >
                    Login
                </v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
            </v-flex>
        </v-layout>
</v-container>
</template>


<script>
import axios from 'axios';
import {FrontendPath} from '../../vuex/api'
let commonService = require("../../services/common.service");
export default {
    data: () => ({

        SnackbarVal: {
           mode: "",
           timeout: 3000,
           snackbar: false,
           color: "success",
           message: ""
        },

        FrontendPath:FrontendPath,
        projectList:[],
        user: {
            email: '',
            password: '',
            project_id:'',
        },
        loadingIcon: false,
        successStatus: false,
        failStatus: false,

        valid: true,

        email: '',
        emailRules: [
        v => !!v || 'User ID is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],

        password: '',
        passwordRules: [
        v => !!v || 'Password is required',
                //v => (v && v.length <= 10) || 'Name must be less than 10 characters'
                ],


            }),

    mounted: function () {

    },

    created() {    
        commonService.getAllData("get-project-list").then(res => {
          this.projectList = res;
      });
    },

    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.authenticateUsers();
            }
        },

        authenticateUsers: function () {
            let user = this.user;
            let self = this;
            this.loadingIcon = true;
            this.$store.dispatch('authenticateUser', {user}).then((res) => { 
                if(res.status == "success"){
                 localStorage.name = 'newName';
                 localStorage.setItem('accessToken', res.accessToken);
                 self.successStatus = true;
                 self.$router.push({'path': '/dashboard'});
                 location.reload(); 
             }
             else
             {
                
            this.SnackbarVal.snackbar = true
            this.SnackbarVal.color = "error"
            this.SnackbarVal.message ="Login failed! Invalid email or password" 

            self.failStatus = true
            }
        }).catch((err) => {
            console.log(err)
        })
    },

    clear() {
        this.$refs.form.reset()
    },           
},
components: {}
};
</script>

<style>
.back{
    background-image: 
}    
</style>




// WEBPACK FOOTER //
// src/components/security/login.vue